export const getCreateQuestionOpened = (state) => state.utils.createQuestionOpened
export const getLoading = (state) => state.utils.isLoading
export const getCategoryPreviewImg = (state) => state.utils.categoryPreviewImg
export const getIsError = (state) => state.utils.isError
export const getErrorMessage = (state) => state.utils.errorMessage
export const getPopUpMessage = (state) => state.utils.popUpMessage
export const getIsPoppedUp = (state) => state.utils.isPoppedUp
export const getCreateAnswerOpened = (state) => state.utils.addAnswerOpened
export const getOpenedQuestionId = (state) => state.utils.openedQuestionId
export const getInputsValid = (state) => state.utils.inputsValid